var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileMenuBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27.379,
    viewBox: "0 0 28 27.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(-90.5 -385.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_12",
    "data-name": "L\\xEDnea 12",
    x2: 24,
    transform: "translate(92.5 387.5)",
    fill: "none",
    stroke: "#5178b5",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_14",
    "data-name": "L\\xEDnea 14",
    x2: 24,
    transform: "translate(92.5 410.879)",
    fill: "none",
    stroke: "#5178b5",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_13",
    "data-name": "L\\xEDnea 13",
    x2: 14.5,
    transform: "translate(102 399.5)",
    fill: "none",
    stroke: "#5178b5",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMenuBlue);
export default __webpack_public_path__ + "static/media/profile-menu-blue.4e3e941b4c7ff8f4ab65dcf12ab77e99.svg";
export { ForwardRef as ReactComponent };